import { InjectionToken } from '@angular/core';
import { Environment } from '@marmon/shared/types/common';

export const ENVIRONMENT = new InjectionToken<Environment>('EnvironmentToken');
